import { render, staticRenderFns } from "./teacherWithQrcode.vue?vue&type=template&id=2ebf6d45&scoped=true&"
import script from "./teacherWithQrcode.vue?vue&type=script&lang=js&"
export * from "./teacherWithQrcode.vue?vue&type=script&lang=js&"
import style0 from "./teacherWithQrcode.vue?vue&type=style&index=0&id=2ebf6d45&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf6d45",
  null
  
)

export default component.exports